<sol-global-search-input
  [value]="term"
  (searchValueChange)="onSearchValueChange(($event || '').toLocaleLowerCase())"
  [style.width]="'100%'"
  [style.height]="'100%'"
>
  <sol-global-search-input-results>
    <app-global-search-history-results
      *ngIf="records.length === 0 && isBusy === false; else searchResultsRef"
      [results]="histories"
    ></app-global-search-history-results>
    <ng-template #searchResultsRef>
      <app-global-search-record-results
        [term]="term"
        [results]="records"
      ></app-global-search-record-results>
    </ng-template>
  </sol-global-search-input-results>

  <sol-global-search-input-footer [count]="records.length || histories.length">
    <div
      center
      *ngIf="isBusy; else buttonRef"
      class="fx-col global-search-spinner"
    >
      <mat-spinner mode="indeterminate" [diameter]="30"> </mat-spinner>
    </div>
    <ng-template #buttonRef>
      <button
        *ngIf="records.length"
        center
        (click)="onViewAllRecordsClick()"
        (pointerup)="onViewAllRecordsClick()"
        mat-button
        color="accent"
      >
        View All Records
      </button>
    </ng-template>
  </sol-global-search-input-footer>
</sol-global-search-input>
